import { render } from "./FeatureCard.vue?vue&type=template&id=2e40535a"
import script from "./FeatureCard.vue?vue&type=script&lang=js"
export * from "./FeatureCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\matress-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__